// extracted by mini-css-extract-plugin
module.exports = {"link":"styles_link__3LatU","header":"styles_header__tkQFh"};